import React from 'react'

import { DocumentCard } from '@frame/ui-components/document-card'
import { DocumentCardContextProvider } from '@frame/ui-components/document-card/context'

import { useFileUploadContext } from '@documents/contexts/file-upload-context'
import { FileUploadState, TrackedFile } from '@documents/types'
import { SelectedFileToRemove } from '@documents/v2/screens/upload-documents'

type Props = {
  files: TrackedFile[]
  hideClassification: boolean
  setSelectedFileToRemove: (selected: SelectedFileToRemove) => void
}

export function Files({ files, hideClassification, setSelectedFileToRemove }: Props) {
  const { deleteFile, retryUploadFile } = useFileUploadContext()

  return (
    <>
      {files.map((file) => {
        const { state, tempId, classificationResults } = file
        const isLoading = state === FileUploadState.PROCESSING
        const onDelete = () => deleteFile({ tempId, fileId: file.uploadedData?.uploaded_file_id })
        const onRetry = () => retryUploadFile(file)
        return (
          <DocumentCardContextProvider
            key={tempId}
            hideClassification={hideClassification}
            fileUploadState={state}
            classificationResults={classificationResults}
            setSelectedFileToRemove={setSelectedFileToRemove}
          >
            <DocumentCard
              file={file.file}
              tempId={tempId}
              fileId={file.uploadedData?.uploaded_file_id}
              isLoading={isLoading}
              onDelete={onDelete}
              onRetry={onRetry}
              isRetryable={file.isRetryable}
              error={file.error}
            />
          </DocumentCardContextProvider>
        )
      })}
    </>
  )
}
